<script setup lang="ts">
import type { HTMLAttributes } from 'vue';
import { cn } from '@/lib/utils';

const props = defineProps<{
  class?: HTMLAttributes['class'];
}>();
</script>

<template>
  <th
    :class="
      cn(
        'tw-h-10 tw-px-2 tw-text-left tw-align-middle tw-font-medium tw-text-neutral-500 [&:has([role=checkbox])]:tw-pr-0 [&>[role=checkbox]]:tw-translate-y-0.5 dark:tw-text-neutral-400',
        props.class
      )
    "
  >
    <slot />
  </th>
</template>
